import React, {PureComponent} from "react"
import {InjectedIntl} from "react-intl"
import styled from "styled-components"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import {Input, ValidationButton} from "@irati/ui/src/FormItem"
import authentication from "@irati/auth"
import Validation from "@irati/utils/validation"
import {H3, Body} from "@irati/ui/src/Typography"
import Card from "@irati/ui/src/Layout/Card"
import media, {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"
import {importChiliPiper} from "../../helpers/loadChiliPiper"

const BannerCTACard = styled(Card)`
  margin: ${padding.base} auto;
  border-radius: 15px;
  ${minWidthMedia.tablet`
    max-width: 360px;
    margin: 0
  `}
  ${media.phone`
    width: 85%;
    margin: 30px auto;
  `}
`

const BannerCTAHeading = styled(H3)`
  text-align: left;
  padding-bottom: 0;
  ${minWidthMedia.desktop`
    max-width: 200px;
  `}
`

const StyledInput = styled(Input)`
  width: 100%;
  margin-top: 15px;
  .col-xs-12 {
    padding: 0;
  }
`

const StyledValidationButton = styled(ValidationButton)`
  margin-top: 30px;
`

const Hr = styled.hr`
  margin: 0;
`

interface Props extends InjectedIntl {}

interface State {
  phone: string
  disabled: boolean
}

class Callback extends PureComponent<Props, State> {
  state = {
    phone: "",
    disabled: false
  }

  componentDidMount = () => {
    const {phone} = authentication.user()
    if (phone) {
      this.setState({phone})
    }
  }

  updatePhone = (phone: string) => this.setState({phone})

  phoneValidation = () => {
    const msgInvalid = "medical.upsellPage.phoneNumber.invalid"
    return Validation.string("medical.upsellPage.phoneNumberr.required")
      .matches(/[0-9()+ ]/, msgInvalid)
      .min(7, msgInvalid)
      .max(15, msgInvalid)
  }

  handleOnClick = () => {
    const {formatMessage} = this.props
    const {phone} = this.state
    const {firstname, lastname, email} = authentication.user()
    const {public_name} = authentication.userTenant()
    this.setState({disabled: true})
    importChiliPiper().then(() => {
      window.ChiliPiper.submit("perkbox", "uk-medical-cross-sell-router", {
        title: formatMessage({id: "medical.upsellPage.callback.chilipiper.title"}),
        titleStyle: "WorkSansMedium 22px #3e3d36",
        onClose: () => {
          this.setState({disabled: false})
        },
        lead: {
          firstName: firstname,
          lastName: lastname,
          email,
          phone,
          company: public_name
        }
      })
    })
  }

  render() {
    const {formatMessage} = this.props
    const {phone, disabled} = this.state
    return (
      <BannerCTACard>
        <BannerCTAHeading base>
          <FormattedMessage id="medical.upsellPage.callback.header" />
        </BannerCTAHeading>
        <Body small marginBottom={1} weight="light">
          <FormattedMessage id="medical.upsellPage.callback.subHeader" />
        </Body>
        <Hr />
        <StyledInput
          label={formatMessage({id: "medical.upsellPage.callback.mobile"})}
          name="contactNumber"
          placeholder={formatMessage({id: "medical.upsellPage.callback.placeholder"})}
          value={phone}
          validation={this.phoneValidation()}
          onChange={this.updatePhone}
        />
        <StyledValidationButton full large primary onClick={this.handleOnClick} disabled={disabled}>
          <FormattedMessage id="medical.upsellPage.callback.buttonText" />
        </StyledValidationButton>
      </BannerCTACard>
    )
  }
}

export default injectIntl(Callback)
